/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <navbar
      v-if="pageRequiresAuth && requiredData && !isFreeTrial"
    />
    <navbar-basic
      v-else
    />
    <notifier />
    <section
      id="content"
      role="main"
      :class="mainClasses"
    >
      <router-view
        v-if="requiredData || $route.meta.requiresAuth !== true"
      />
    </section>
    <footer
      class="text-center small"
      style="font-size: 11px; color: #999;"
    >
      <hr>
      Copyright &copy; 2015-{{ (new Date()).getFullYear() }} VoiceVibes, Inc, All rights reserved.<br>
      <span class="hidden-print">
        This material is based upon work supported by the National Science Foundation under Grants Number 1520228 and 1632582.<br>
        Any opinions, findings, and conclusions or recommendations expressed in this material are those of the author(s) and do not necessarily reflect the views of the National Science Foundation.
      </span>
      <vue-announcer />
    </footer>
  </div>
</template>

<style lang="less">
  @import '../src/less/base.less';
</style>

<script>
import Navbar from './components/layout/Navbar';
import NavbarBasic from './components/layout/NavbarBasic';
import Notifier from './components/layout/Notifier';
import AssignmentModes from './components/specials/AssignmentModes';

export default {
  components: { Navbar, NavbarBasic, Notifier },
  mixins: [ AssignmentModes ],
  computed: {
    mainClasses: {
      cache: false,
      get() {
        return (this.assignmentsEnabled && this.currentMode && this.currentMode == 'manager') ?
          'container-fluid coachMode' : 'container-fluid';
      }
    },
    assignmentsEnabled() {
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' && org.settings.Assignments);
    },
    user: {
      cache: false,
      get() {
        return this.$store.getters.user;
      }
    },
    pageRequiresAuth: {
      cache: false,
      get() {
        return (this.$route.meta && this.$route.meta.requiresAuth);
      }
    },
    isFreeTrial: {
      cache: false,
      get() {
        return !!(this.user && this.user.metadata && this.user.metadata.freeTrial);
      }
    },
    requiredData: {
      cache: false,
      get() {
        return this.$store.getters.user && this.$store.getters.org && this.$store.getters.groups;
      }
    }
  },
};
</script>
